import { getCookie, setCookie, deleteCookie } from './cookie';

export function setLoginCookie(cookieName, duration) {
    if (!getCookie(cookieName)) {
        const date = new Date();

        date.setSeconds(duration);
        setCookie(
            `${cookieName}=${cookieName}; ` +
            `domain=.${location.host.split('.').slice(1).join('.')}; ` +
            'path=/; ' +
            `expires=${date.toUTCString()}`);
    }
}

export function deleteLoginCookie(cookieName) {
    if (getCookie(cookieName)) {
        deleteCookie(
            cookieName,
            location.host.split('.').slice(1).join('.'),
        );
    }
}



// WEBPACK FOOTER //
// /src/js/common/utils/loginCookies.js